// extracted by mini-css-extract-plugin
export var cdsAssistiveText = "Main-module--cds--assistive-text--be100";
export var cdsVisuallyHidden = "Main-module--cds--visually-hidden--8d403";
export var hideFeedback = "Main-module--hide-feedback--855ca";
export var main = "Main-module--main--f2fa6";
export var padded = "Main-module--padded--1cdb6";
export var showFeedback = "Main-module--show-feedback--a04e6";
export var skeleton = "Main-module--skeleton--fe1a8";